export default function formatTimestamp(timestampString) {
  const date = new Date(timestampString).toLocaleString('en-US', {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit', second: '2-digit', timeZoneName: 'short',
  });
  // convert MM/DD/YYYY to MM-DD-YYYY
  return date.replace(/\//g, '-');
}
